<template>
  <div class="cookie" v-if="isOpen">
    <div class="cookie_content">
      <img src="@/assets/svg/cookie.svg" alt="">
      <h2>Cookies</h2>
      <p v-html="message">{{ message }}</p>
      <div class="button-wrapper">
        <button class="btn-small btn-blue" @click="accept">
          {{ buttonAccept }}
        </button>
        <button class="btn-small btn-gray" @click="deny">
          {{ buttonDeny }}
        </button>
      </div>
      <router-link class="learn" to="/impressum#Cookies"
        >mehr erfahren</router-link
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    buttonAccept: {
      default: "Akzeptieren"
    },
    buttonDeny: {
      default: "Ablehnen"
    },
    message: {
      default:
        "Unsere Website nutzt Cookies, um dir bestmögliche Funktionalität bieten zu können."
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  created() {
    if (!this.getGDPR() === true) {
      this.isOpen = true;
    }
  },
  methods: {
    getGDPR() {
      return localStorage.getItem("GDPR:accepted", true);
    },
    accept() {
      this.isOpen = false;
      localStorage.setItem("GDPR:accepted", true);
      location.reload();
    },
    deny() {
      this.isOpen = false;
      localStorage.setItem("GDPR:accepted", false);
      location.reload();
    }
  }
};
</script>
<style lang="scss" scoped>
.cookie {
  position: fixed;
  bottom: 3vh;
  right: 2vw;
  background: #f5f4f3;
  border-radius: 15px;
  width: 28rem;
  height: calc(28rem * 1.3);
  -webkit-box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 20px 20px rgba(0, 0, 0, 0.1);
  z-index: 100;
  .cookie_content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
    padding: 2rem 3rem;
    img {
      width: 5rem;
    }
    p {
      text-align: center;
      font-size: 1.2rem;
      font-weight: 400;
    }
    .button-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: calc(28rem / 3.3);
    }
    .learn {
      font-size: 1.2rem;
      font-weight: 400;
    }
  }
}
@media only screen and (max-width: 1024px) {
  .cookie {
    width: 90vw;
    height: 33vh;
    left: 5vw;
    right: 5vw;
    .cookie_content {
      padding: 2rem 1.5rem;
      .button-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
      }
    }
  }
}
</style>
